export default __webpack_public_path__ + "static/media/rain.715bf67a.svg";